import type { T_CountryItem } from '@fe/types/modules/localization/common/client/types';
import { useContext } from 'preact/hooks';

import { CountryCodeSelectorContext } from '@/context/CountryCodeSelectorContext';

import FlagIcon from './FlagIcon';

export default function CountryCodeItem({ country }: { country: T_CountryItem }) {
  const { handleSelect, setIsOpen } = useContext(CountryCodeSelectorContext);

  return (
    <button
      className='flex w-full items-center rounded-md border border-transparent bg-white px-3 py-2 text-sm outline-none hover:border-gray-200 hover:bg-[#fafafa]'
      onClick={() => {
        if (country.dialCode) {
          handleSelect(country);
          setIsOpen(false);
        }
      }}
    >
      <FlagIcon countryAcronym={country.isoCode} />
      <span className='ml-2'>{country.name}</span>
      <span className='ml-auto'>{country.dialCode}</span>
    </button>
  );
}
